exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-5122263a]{--tw-bg-opacity:1;background-color:rgb(19 19 19/var(--tw-bg-opacity))}.idle-container[data-v-5122263a]{height:100%;width:100%;background-size:cover;background-position:50%}.button[data-v-5122263a],.idle-container[data-v-5122263a]{display:flex;align-items:center;justify-content:center}.button[data-v-5122263a]{height:4rem;width:4rem;cursor:pointer;border-radius:9999px;--tw-bg-opacity:1;background-color:rgb(24 24 24/var(--tw-bg-opacity))}", ""]);

// exports
